<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Spaces Between</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#part-one-last-nights-witches-zooming-home-late">Part One Last Night’s Witches (Zooming Home Late)</a></li>
<li id="toc-li-6"><a href="#/text/ch006#part-two-looking-for-the-hedgehog">Part Two Looking for The Hedgehog</a></li>
<li id="toc-li-7"><span href="#/text/ch007#part-three-every-tatter" title="Link target outside of Sample">Part Three Every Tatter</span></li>
<li id="toc-li-8"><span href="#/text/ch008#harry" title="Link target outside of Sample">Harry</span></li>
<li id="toc-li-9"><span href="#/text/ch009#part-four" title="Link target outside of Sample">Part Four</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?186e11b0